if (!customElements.get('collection-grid')) {
  class CollectionGrid extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.handleUpdateRef = this.handleUpdate.bind(this);
      this.handleShowMoreRef = this.handleShowMore.bind(this);
      this.handleLayoutChangeRef = this.handleLayoutChange.bind(this);
    }

    /**
     * @param {String} section
     * @returns {Object<Document, HTMLElement>}
     */
    getNewGridHTML(section) {
      const html = new DOMParser().parseFromString(section, 'text/html');
      return { html, collectionGrid: html.querySelector('collection-grid') };
    }

    handleUpdate(event) {
      if (!event.detail.url) return;

      getSections([this.sectionId], event.detail.url).then(res => res.json()).then(data => {
        if (!data[this.sectionId]) return;

        const { html, collectionGrid } = this.getNewGridHTML(data[this.sectionId]);
        document.dispatchEvent(new CustomEvent('alexa:update-show-more', { detail: { html } }));

        if (!collectionGrid) return;

        this.innerHTML = collectionGrid.innerHTML;
      }).catch(err => console.error(err));
    }

    handleShowMore(event) {
      if (!event.detail.url) return;

      getSections([this.sectionId], event.detail.url).then(res => res.json()).then(data => {
        if (!data[this.sectionId]) return;

        const { html, collectionGrid } = this.getNewGridHTML(data[this.sectionId]);
        document.dispatchEvent(new CustomEvent('alexa:update-show-more', { detail: { html } }));

        if (!collectionGrid) return;

        this.insertAdjacentHTML("beforeend", collectionGrid.innerHTML);
      }).catch(err => console.error(err));
    }

    handleLayoutChange(event) {
      if(!event.detail.view) return;

      this.setAttribute('data-view', event.detail.view);
    }

    disconnectedCallback() {
      document.removeEventListener('alexa:collection-grid-show-more', this.handleShowMoreRef);
      document.removeEventListener('alexa:update-collection-grid', this.handleUpdateRef);
      document.removeEventListener('alexa:collection-grid-layout-change', this.handleLayoutChangeRef);
    }

    connectedCallback() {
      document.addEventListener('alexa:collection-grid-show-more', this.handleShowMoreRef);
      document.addEventListener('alexa:update-collection-grid', this.handleUpdateRef);
      document.addEventListener('alexa:collection-grid-layout-change', this.handleLayoutChangeRef);
    }
  }
  customElements.define('collection-grid', CollectionGrid);
}
